import axiosInstance from './apiClient'
import { getErrorMessage } from '@/lib/utils'
import { TimerConfig } from '@/redux/slices/timerConfigurationSlice'

export const fetchTimerConfigurationAPI = async (roomId: string) => {
  try {
    const response = await axiosInstance.get(
      `/oge/rooms/${roomId}/timer-config/`
    )
    return response.data
  } catch (error) {
    throw new Error(getErrorMessage(error))
  }
}

export const saveTimerConfigurationAPI = async (
  roomId: string,
  config: TimerConfig
) => {
  try {
    const response = await axiosInstance.post(
      `/oge/rooms/${roomId}/timer-config/`,
      config
    )
    return response.data
  } catch (error) {
    throw new Error(getErrorMessage(error))
  }
}
